var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showContentFullTextMenu)?_c('div',{staticClass:"popup-menu content-full-text-menu elevation-5 list-table",style:(_vm.style),attrs:{"id":"content-full-text-menu"},domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }